import {
  Box,
  Typography,
  Divider,
  TextField,
  Button,
  Collapse,
  Alert,
  CircularProgress,
  Grid,
} from '@mui/material';
import CloseButton from '../../../../components/closebutton/CloseButton';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ProvinceUpdateModel } from '../../model/destination.model';
import { destinationUpdateSchema } from '../../model/destination.schema';
import { useEffect } from 'react';

interface Props {
  label: string;
  loading: boolean;
  message: string | null;
  defaultValues: ProvinceUpdateModel | null;
  onClose: () => void;
  onSubmit: (form: ProvinceUpdateModel) => void;
}

const ProvinceModalUpdate = ({
  label,
  loading,
  message,
  defaultValues,
  onClose,
  onSubmit,
}: Props) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<ProvinceUpdateModel>({
    resolver: yupResolver(destinationUpdateSchema),
    defaultValues: defaultValues ?? undefined,
  });

  useEffect(() => {
    if (defaultValues) reset(defaultValues);
  }, [defaultValues]);

  return (
    <Box sx={{ width: '100%' }}>
      <Box padding={4}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography fontSize="24px">ແກ້ໄຂ{label}</Typography>
          <CloseButton onClick={onClose} />
        </Box>
        <Divider sx={{ backgroundColor: '#1A1A1A20', mt: 1.5, mb: 2.5 }} />

        <Collapse unmountOnExit orientation="vertical" in={!!message}>
          <Alert severity="error" sx={{ mb: 2 }}>
            {message ?? ''}
          </Alert>
        </Collapse>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container marginTop="10px" spacing={3}>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                label={`ຊື່${label} (LA)`}
                placeholder="please enter"
                error={!!errors.title_la}
                helperText={errors.title_la?.message}
                {...register('title_la')}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                label={`ຊື່${label} (EN)`}
                placeholder="please enter"
                error={!!errors.title_en}
                helperText={errors.title_en?.message}
                {...register('title_en')}
              />
            </Grid>
          </Grid>

          <Box mt="30px" />
          <TextField
            fullWidth
            size="small"
            multiline
            rows={4}
            InputLabelProps={{ shrink: true }}
            label="ເນື້ອໃນ"
            placeholder="ປ້ອນຄໍາອະທິບາຍ"
            error={!!errors.description}
            helperText={errors.description?.message}
            {...register('description')}
          />

          <Box sx={{ display: 'flex', gap: 2, mt: '50px' }}>
            <Button
              onClick={onClose}
              sx={{ flexGrow: 1, borderRadius: '100px', height: '41px' }}
              variant="outlined"
              size="small"
              fullWidth
            >
              ຍົກເລີກ
            </Button>
            <Button
              type="submit"
              sx={{ flexGrow: 1, borderRadius: '100px', height: '41px' }}
              size="small"
              fullWidth
              variant="contained"
              disabled={loading}
            >
              <Collapse unmountOnExit orientation="horizontal" in={loading}>
                <CircularProgress size="20px" sx={{ color: 'white', marginRight: '10px' }} />
              </Collapse>
              ບັນທຶກ
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default ProvinceModalUpdate;
